import { render, staticRenderFns } from "./FeatureWrapper.vue?vue&type=template&id=67f6bdfe"
import script from "./FeatureWrapper.vue?vue&type=script&lang=js"
export * from "./FeatureWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports